import { render, staticRenderFns } from "./TimelineTics.vue?vue&type=template&id=505a308e&scoped=true"
import script from "./TimelineTics.vue?vue&type=script&lang=js"
export * from "./TimelineTics.vue?vue&type=script&lang=js"
import style0 from "./TimelineTics.vue?vue&type=style&index=0&id=505a308e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505a308e",
  null
  
)

export default component.exports